import {FC, useState} from 'react';
import {Box, Typography} from '@mui/material';
import Button from '@components/Button';
import UploadImage from '@/shared/components/UploadDropzone/UploadImage';
import {H6} from '@/utils/constants';
import {changePhotoModal} from './changePhotoModal.style';

interface ConfirmationModalProps {
	onCloseModal: () => void;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({onCloseModal}) => {
	const [avatar, setAvatar] = useState<File | null>(null);

	const handleLogoChange = (logo: File) => setAvatar(logo);

	const handleMainBtn = () => {
		onCloseModal();
	};

	return (
		<Box sx={changePhotoModal.content}>
			<Typography variant={H6} sx={changePhotoModal.title}>
				Move and Scale
			</Typography>

			<Box sx={changePhotoModal.imagePickerWrap}>
				<UploadImage
					onChange={handleLogoChange}
					image={avatar}
					isImage
					parentClassName={changePhotoModal.imageLoader}
				/>
			</Box>
			<Box sx={changePhotoModal.btnWrap}>
				<Button variant="outline" sx={changePhotoModal.btn} onClick={onCloseModal} title="Cancel">
					Confirm
				</Button>
				<Button sx={changePhotoModal.btn} onClick={handleMainBtn} title="Confirm">
					Cancel
				</Button>
			</Box>
		</Box>
	);
};

export default ConfirmationModal;
